// Date helpers shared by Goals, Schedule and Dashboard for YYYYMMDD values.

/** YYYYMMDD → YYYY-MM-DD (native date input). */
export const toInputDate = (yyyymmdd?: string): string => {
  if (!yyyymmdd || yyyymmdd.length !== 8) return "";
  return `${yyyymmdd.slice(0, 4)}-${yyyymmdd.slice(4, 6)}-${yyyymmdd.slice(6, 8)}`;
};

/** YYYY-MM-DD → YYYYMMDD. */
export const fromInputDate = (value: string): string => value.replace(/-/g, "");

/** Today as YYYYMMDD in local time. */
export const todayYYYYMMDD = (): string => {
  const now = new Date();
  return `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, "0")}${String(
    now.getDate(),
  ).padStart(2, "0")}`;
};

export const formatDisplayDate = (
  yyyymmdd?: string,
  options: Intl.DateTimeFormatOptions = {
    day: "numeric",
    month: "short",
    year: "numeric",
  },
): string => {
  const iso = toInputDate(yyyymmdd);
  if (!iso) return "";
  const d = new Date(`${iso}T00:00:00`);
  if (isNaN(d.getTime())) return "";
  return d.toLocaleDateString(undefined, options);
};

/** "12 Mar" or "12 – 14 Mar 2027" for a date range. */
export const formatDateRange = (start?: string, end?: string): string => {
  if (!start) return "";
  if (!end || end === start) return formatDisplayDate(start);
  const sameMonth = start.slice(0, 6) === end.slice(0, 6);
  const startLabel = formatDisplayDate(
    start,
    sameMonth ? { day: "numeric" } : { day: "numeric", month: "short" },
  );
  return `${startLabel} – ${formatDisplayDate(end)}`;
};

export const daysUntil = (yyyymmdd?: string): number | null => {
  const iso = toInputDate(yyyymmdd);
  if (!iso) return null;
  const target = new Date(`${iso}T00:00:00`);
  if (isNaN(target.getTime())) return null;
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.round((target.getTime() - today.getTime()) / 86400000);
};

export const countdownLabel = (yyyymmdd?: string): string | null => {
  const days = daysUntil(yyyymmdd);
  if (days === null) return null;
  if (days === 0) return "Today";
  if (days === 1) return "Tomorrow";
  if (days > 0) return `In ${days} days`;
  return `${Math.abs(days)} days ago`;
};
